import "./TogglePills.scss";

export type ToggleBadgeVariant = "alert" | "warning" | "success";

type ToggleOption<T extends string> = {
  label: string;
  value: T;
  badge?: string;
  badgeVariant?: ToggleBadgeVariant;
};
type TogglePillsProps<T extends string> = {
  options: readonly ToggleOption<T>[];
  value: T;
  onChange: (value: T) => void;
};

const TogglePills = <T extends string>({ options, value, onChange }: TogglePillsProps<T>) => {
  return (
    <div className="toggle">
      {options.map(({ label, value: optionValue, badge, badgeVariant = "alert" }) => {
        const isActive = value === optionValue;
        return (
          <button key={optionValue} onClick={() => onChange(optionValue)} className={`toggle__pill ${isActive ? "toggle__pill--active" : ""}`} type="button">
            <div className="toggle__label">
              {label}
            </div>
            {badge && (
              <span className={`toggle__badge toggle__badge--${badgeVariant} label-medium-medium`}>
                {badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default TogglePills;
